export const WORKLOAD_RECOMMENDATION_MIN_CONFIDENCE = 0.9;

export const STANDARD_WORKLOAD_KINDS = [
  'CronJob',
  'DaemonSet',
  'Deployment',
  'ReplicaSet',
  'Rollout',
  'StatefulSet',
];
